import { render } from "./Resumen.vue?vue&type=template&id=1e7ae6b4&scoped=true&ts=true"
import script from "./Resumen.vue?vue&type=script&lang=ts"
export * from "./Resumen.vue?vue&type=script&lang=ts"

import "./Resumen.vue?vue&type=style&index=0&id=1e7ae6b4&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7ae6b4"]])

export default __exports__